import type { BentoFeatureCardData } from './data';

interface BentoFeatureCardProps {
  data: BentoFeatureCardData;
}

export default function BentoFeatureCard({ data }: BentoFeatureCardProps) {
  return (
    <article className="flex flex-col rounded-3xl bg-primary-50 p-7 md:p-8">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50 text-primary-600">
        <i className={`${data.icon} text-xl`}></i>
      </span>

      <h3 className="mt-6 font-heading text-xl font-bold leading-tight tracking-[-0.01em] text-foreground-950 md:text-2xl">
        {data.titleLead} <span className="text-primary-600">{data.titleAccent}</span>
      </h3>

      <p className="mt-4 text-sm leading-relaxed text-foreground-600">{data.description}</p>

      <ul className="mt-6 space-y-3">
        {data.checklist.map((item) => (
          <li key={item} className="flex items-center gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-check-line text-sm"></i>
            </span>
            <span className="text-sm font-medium text-foreground-800">{item}</span>
          </li>
        ))}
      </ul>
    </article>
  );
}